module.exports = __webpack_public_path__ + "img/IMG-20191012-WA0032.4adec104.jpg";